import auth from './auth'
import form from './form'
import cart from './cart'
import delivery from './delivery'
import product from './product'


$(function(){
  $.ajaxSetup({
    headers: { 'X-CSRF-TOKEN': $('meta[name="token"]').attr('content') }
  });
})

const API = {
  auth,
  form,
  cart,
  delivery,
  product,

  get(url, data = {}) {
    return new Promise(resolve => {
      $.get(url,data,resolve)
    })
  },
  post(url, data = {}) {
    return new Promise((resolve, reject) => {
      $.post(url,data,resolve)
        .fail(reject)
    })
  },
}

export default API
